import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { OrdersComponent } from './orders/orders.component';
import { OrderDetailsComponent } from './details/details.component';

export const ordersRoutes: Routes = [
    {
        path: 'markiezen/orders',
        component: OrdersComponent,
        data: { type: 'markiezen' },
    },
    {
        path: 'markiezen/orders/:orderId',
        component: OrderDetailsComponent,
        data: { type: 'markiezen' },
    },
    {
        path: 'kokers-en-profielen/orders',
        component: OrdersComponent,
        data: { type: 'kokers' },
    },
    {
        path: 'kokers-en-profielen/orders/:orderId',
        component: OrderDetailsComponent,
        data: { type: 'kokers' },
    },
];

export const ordersRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(ordersRoutes);
